import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import authService from "../services/authService";
import AppLayout from "../components/AppLayout";
import Footer from "../components/Footer";
import "./VerifyEmail.css";

function VerifyEmail() {
  const { token } = useParams(); // pega o token da URL
  const navigate = useNavigate();
  const [status, setStatus] = useState("");

  useEffect(() => {
    async function verify() {
      try {
        const response = await authService.verifyEmail(token);
        setStatus("success");
        // após alguns segundos, redireciona para login
        setTimeout(() => navigate("/login"), 3000);
      } catch (error) {
        setStatus("error");
      }
    }
    verify();
  }, [token, navigate]);

  return (
    <AppLayout>
      <div className="verify-container">
        <h2>📧 Verificar Email</h2>
        {status === "" && <p>Verificando seu email...</p>}
        {status === "success" && (
          <p className="verify-success">
            ✅ Email verificado com sucesso! Você será redirecionado para o login.
          </p>
        )}
        {status === "error" && (
          <p className="verify-error">
            ❌ O link de verificação expirou ou é inválido. Solicite um novo registro.
          </p>
        )}
      </div>
      <Footer />
    </AppLayout>
  );
}

export default VerifyEmail;
